export const parseCountryIds = (value) => {
  if (!value) return [];
  if (Array.isArray(value)) return value.map((v) => String(v).trim()).filter(Boolean);
  return String(value).split(',').map((v) => v.trim()).filter(Boolean);
};

export const serializeCountryIds = (value) => {
  const ids = parseCountryIds(value);
  return ids.length ? ids.join(',') : '';
};

export const buildCountryMap = (countries = []) => {
  const map = new Map();
  countries.forEach((country) => {
    map.set(String(country.id), country);
  });
  return map;
};

export const getCountryNameById = (id, countries = [], fallback = '-') => {
  if (!id) return fallback;
  const country = countries.find((item) => String(item.id) === String(id));
  return country?.name?.trim() || fallback;
};

export const formatCountryIds = (value, countries = [], fallback = '-') => {
  const ids = parseCountryIds(value);
  if (!ids.length) return fallback;
  return ids.map((id) => getCountryNameById(id, countries, id)).join(', ');
};

export const getCountryDisplay = (record, field, countries = []) => {
  const nameField = `${field}_name`;
  if (record?.[nameField]) return record[nameField];
  return formatCountryIds(record?.[field], countries);
};
